import React from 'react'
import { Typography } from '@mui/material'
import { onDark } from '../theme'

// The quiet line a drawer card shows when it has nothing to list, e.g. "None prescribed".
const EmptyNote = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="subtitle2" sx={{ color: onDark.secondary }}>
    {children}
  </Typography>
)

export default EmptyNote
